import axios from 'axios';
// Import the supabase client to get the session/token
import { supabase } from './supabaseClient'; 

// Base URL is read from environment variables. 
// VITE_API_URL is set in .env (development) or .env.production (production)
const baseURL = import.meta.env.VITE_API_URL;

if (!baseURL) {
  console.error("VITE_API_URL is not defined. Please check your .env file.");
  // Optionally, you could throw an error or default to a safe value
}

export const axiosInstance = axios.create({
  baseURL,
  withCredentials: true, // This enables sending cookies with requests
});

// Request interceptor to ensure FormData requests can set their own multipart boundary
axiosInstance.interceptors.request.use(
  (config) => {
    const isFormData =
      typeof FormData !== 'undefined' && config.data instanceof FormData;

    if (isFormData && config.headers) {
      // Let axios/browser set multipart/form-data boundary automatically
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Request interceptor for AUTHENTICATION
axiosInstance.interceptors.request.use(
  async (config) => {
    // Get the current session from Supabase
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error) {
        console.error('Error getting Supabase session in axios interceptor:', error);
        // Decide if you want to proceed without token or block request
        return config; // Proceed without token for now
    }

    if (session?.access_token) {
        // console.log('Adding Auth header to request:', config.url);
        if (!config.headers) config.headers = {};
        config.headers['Authorization'] = `Bearer ${session.access_token}`;
    }
    // else {
    //     console.log('No active session, request sent without Auth header:', config.url);
    // }
    
    return config;
  },
  (error) => {
    console.error('Axios request interceptor error (before send):', error);
    return Promise.reject(error);
  }
);

// Request interceptor for logging
axiosInstance.interceptors.request.use(
  (config) => {
    // Debug: Log the request configuration
    console.log('Axios request config:', {
      url: config.url,
      method: config.method,
      contentType: config.headers?.['Content-Type'] || config.headers?.['content-type'],
    });
    
    return config;
  },
  (error) => {
    console.error('Axios request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('Axios response success:', {
      url: response.config.url,
      status: response.status,
      statusText: response.statusText
    });
    return response;
  },
  (error) => {
    console.error('Axios response error:', {
      url: error.config?.url,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      console.warn('Authentication error (401) detected, redirecting to login');
      // Clear any stored user data
      localStorage.removeItem('user');
      // Redirect to login page on authentication error
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
